var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","highlight-row":"","stripe":"","max-height":"700"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }